/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React, { FunctionComponent, useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { getAEMResource, isAppReady } from '../../selectors/generic';
import { isLoadingById } from '../../selectors/loader';
import { CardsContainer } from '../molecules/cards/CardsContainer';
import { RecipeCrossSellComponent } from '../../data/definitions/cross-sell';
import RecipeGridCard from '../molecules/cards/RecipeGridCard';
import { initializeFavoriteRecipes } from '../../actions/recipes';
import { getFavoriteRecipes } from '../../selectors/recipes';
import { useI18N } from '../hoc/withI18N';

interface IProps {
    resourceLoading: boolean;
    resource?: RecipeCrossSellComponent;
}

export const RecipeSocialProof: FunctionComponent<IProps> = ({ resource, resourceLoading }) => {
    const appReady = useSelector(isAppReady);
    const favoriteRecipes = useSelector(getFavoriteRecipes);
    const translate = useI18N();
    const dispatch = useDispatch();

    useEffect(() => {
        if (appReady) {
            dispatch(initializeFavoriteRecipes());
        }
    }, [dispatch, appReady]);

    if (resourceLoading || !resource?.recipes || resource?.recipes?.length < 1) {
        return null;
    }

    return (
        <div className="container">
            <div className="row">
                <div className="social-proof container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <h5>{translate(resource?.title, resource?.productName)}</h5>
                        </div>
                        <div className={'col-md-12' + (!resource?.buttonVisible ? ' p-margin-bottom-sm' : '')}>
                            <div className="row">
                                <CardsContainer>
                                    {resource?.recipes?.map(e => (
                                        <RecipeGridCard
                                            key={e.id}
                                            item={e}
                                            isCarousel
                                            isFavorite={!!favoriteRecipes?.find(favorite => favorite.recipeId === e.id)}
                                        />
                                    ))}
                                </CardsContainer>
                            </div>
                        </div>
                        {resource?.buttonVisible && (
                            <div className="social-proof__button col-md-12 p-flex p-justify-center p-margin-top-md p-margin-bottom-md">
                                <a className="btn-primary" href={resource?.tagLink}>
                                    {translate(resource?.buttonText, resource?.productName)}
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default connect(
    (state, ownProps: any) => ({
        resource: getAEMResource(state, ownProps.model) || {},
        resourceLoading: isLoadingById(state, ownProps.model),
    }),
    {}
)(RecipeSocialProof);
